<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "Sanad",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
</style>

